import { StateCreator } from 'zustand';
import { Store } from '../store.interface';
import { ApplicationOperationManagementStore, RouteType } from './applicationOperationManagementStore.interface';
import { ROUTES } from '../../components/ApplicationOperationManagement/navigation/types/navigationTypes';

export const defaultApplicationOperationManagementStore = {
	currentView: ROUTES.APPLICATIONS,
	selectedApplication: null,
	selectedOperation: null,
	navigationErrors: [],
};

const applicationOperationManagementStore: StateCreator<Store, [], [],ApplicationOperationManagementStore> = (set, get) => ({
	...defaultApplicationOperationManagementStore,

	setCurrentView: (view: RouteType) => set({ currentView: view }),

	setSelectedApplication: (application) => set({ selectedApplication: application }),

	setSelectedOperation: (operation) => set({ selectedOperation: operation }),

	addNavigationError: (error) => {
		const id = `nav-error-${Date.now()}-${Math.random()}`;
		const newError = { ...error, id };

		set({ navigationErrors: [...get().navigationErrors, newError] });
	},

	clearSelections: () =>
		set({
			selectedApplication: null,
			selectedOperation: null,
		}),
});

export default applicationOperationManagementStore;
